/*!

=========================================================
* BLK Design System React - v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/blk-design-system-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/blk-design-system-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import ContactForm from "components/ContactForm/ContactForm";
import CustomModal from "components/CustomModal/CustomModal";
import React from "react";

// reactstrap components
import { Button, Col, Container, Row } from "reactstrap";

export default function PageHeader() {
  const [formModal, setFormModal] = React.useState(false);

  return (
    <div className="page-header header-filter">
      <div className="squares square1" />
      <div className="squares square2" />
      <div className="squares square3" />
      <div className="squares square4" />
      <div className="squares square5" />
      <div className="squares square6" />
      <div className="squares square7" />
      <Container>
        <div className="content-center brand" data-background-color="black">
          <h1 className="h1-seo">
            <span style={{ color: "#e95420" }}>IoT</span> Integration. Done
            right.
          </h1>
          <h3 className="d-none d-sm-block">Get in touch</h3>

          <Row>
            <Col md="10">
              <Button size="lg" onClick={() => setFormModal(true)}>
                Contact us
              </Button>
            </Col>
          </Row>
        </div>

        <CustomModal
          title="Contact us"
          formModal={formModal}
          setFormModal={setFormModal}
        >
          <ContactForm />
        </CustomModal>
      </Container>
    </div>
  );
}
